import React from "react";

export default function Active({ result }) {
  if (result === true) {
    return <i className="pi pi-check text-green-600"></i>;
  } else {
    return <i className="pi pi-times text-red-600"></i>;
  }
}
